import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { PollingStatuses, TextVariableDto } from "app/ApiClient";

export type TranslateVariable = {
  variableName?: string;
  token?: string;
  status?: PollingStatuses;
};

export type TranslationDownloadToken = {
  projectId: number;
  token: string;
};

export type TranslateInitiateTokens = {
  projectId?: number;
  variables?: TranslateVariable[];
};

export type TranslateVariableOrBatteryName = {
  projectId: number;
  name?: string;
};

export interface TranslateState {
  errorMessage?: string;
  downloadTranslateErrorMessage?: string;
  initiateTranslateStatus: LoadingState;
  translateVariables: TextVariableDto[];
  translateInitiateTokens?: TranslateInitiateTokens[];    
  downloadTranslationErrorMessage?: string;
  translationDownloadingState: LoadingState;
  translationDownloadTokens: TranslationDownloadToken[];
  translateResultMessageVariable:TranslateVariableOrBatteryName[];
  translateErrorMessageVariable:TranslateVariableOrBatteryName[];
  presignedUrl: string | null;
}

export const initialTranslate: TranslateState = {
  translateVariables: [],
  initiateTranslateStatus: LoadingState.idle,
  translateInitiateTokens: [],  
  translationDownloadingState: LoadingState.idle,
  translationDownloadTokens: [],
  translateResultMessageVariable:[],
  translateErrorMessageVariable:[],
  presignedUrl:null
};
